export default {
  setting: {},
  labels: {},
  statusList: [],
  refstatusList: [],
  attachmentType: [],
  statusSelect: [],
  sympla: {
    token: ''
  }
}
